<template>
	<!-- width="600px" 或者  width="60%"   -->
	<el-dialog
		:close-on-click-modal="false"
		title="添加电梯"
		:show-close="true"
		:visible="true"
		:before-close="handleBeforeClose"
		width="660px"
	>
		<div class="dialog__container">
			<el-form
				inline
				ref="form"
				class="search-form"
				label-position="right"
				:model="form"
				:rules="rules"
				label-width="70px"
			>
				<el-tabs type="border-card">
					<el-tab-pane label="基本信息">
						<h4>基本信息</h4>
						<el-form-item label="设备编号：" prop="equipmentCode">
							<el-input
								size="mini"
								v-model.trim="form.equipmentCode"
								placeholder="请输入设备编号"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="使用单位：" class="mr0">
							<el-select
								size="mini"
								v-model="form.propertyUnitObj"
								filterable
								placeholder="请选择所属单位"
								clearable
								reserve-keyword
								:remote="true"
								@change="selectLiftObj"
								:remote-method="searchUnitList"
								@visible-change="searchUnitList('')"
								value-key="id"
							>
								<el-option
									v-for="item in unitList"
									:key="item.id"
									:label="item.unitName"
									:value="item"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="所属项目：">
							<el-select
								size="mini"
								v-model="form.projectId"
								filterable
								placeholder="请选择所属项目"
								clearable
								reserve-keyword
								:remote="true"
								:remote-method="searchProjectList"
								@visible-change="searchProjectList('')"
							>
								<el-option
									v-for="item in projectList"
									:key="item.id"
									:label="item.projectName"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="电梯位置：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftLocation"
								placeholder="例：101楼-3门-东梯"
								clearable
							></el-input>
						</el-form-item>
						<h4>使用证编号</h4>
						<el-form-item
							label="使用证编号："
							class="mr0 label-with-five-word input-with-col2"
							label-width="84px"
						>
							<el-input
								size="mini"
								v-model.trim="form.useCertificateNumber"
								placeholder="例：梯翼FFA1111"
								clearable
							></el-input>
						</el-form-item>
						<h4>保养设置</h4>
						<el-form-item label="保养项目：">
							<el-select
								size="mini"
								v-model="form.maintenanceOrderId"
								filterable
								placeholder="请选择保养项目"
								clearable
								reserve-keyword
								:remote="true"
								:remote-method="searchTemplateSimpleList"
								@visible-change="searchTemplateSimpleList('')"
							>
								<el-option
									v-for="item in templateSimpleList"
									:key="item.id"
									:label="item.templateName"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="电子工单：" class="mr0">
							<el-select
								size="mini"
								v-model="form.electronicWorkOrder"
								value-key="dictionaryCode"
							>
								<el-option
									v-for="item in dzgdDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item.dictionaryCode"
									placeholder="电子工单"
								></el-option>
							</el-select>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="电梯参数">
						<h4>设备信息</h4>
						<el-form-item label="电梯类型：">
							<el-select
								size="mini"
								v-model="form.liftParameter.liftTypeCode"
								value-key="dictionaryCode"
								@change="selectLiftType"
							>
								<el-option
									v-for="item in dtlxDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item.dictionaryCode"
									placeholder="请选择电梯类型"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="电梯品牌：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.liftBrand"
								placeholder="请输入电梯品牌："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="制造单位：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.manufactureCompany"
								placeholder="请输入制造单位："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="安装单位：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.installCompany"
								placeholder="请输入安装单位："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="运行方式：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.modeOperation"
								placeholder="请输入运行方式："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="设备型号：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.unitType"
								placeholder="请输入设备型号："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="出厂编号：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.factoryNumber"
								placeholder="请输入出厂编号："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="控制方式：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.controlMode"
								placeholder="请输入控制方式："
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="额定速度：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.nominalSpeed"
								v-number-only:11
								placeholder="0.6m/s"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="载重：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.nominalLoad"
								v-number-only:11
								placeholder="1000KG"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="层站数：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.stationNumber"
								placeholder="10/12"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="注册单位：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.registeredUnit"
								placeholder="注册单位"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="注册代码：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.registerCode"
								placeholder="注册代码"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="管理人员：">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.managerName"
								placeholder="管理人员"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="联系电话：" class="mr0">
							<el-input
								size="mini"
								v-number-only:11
								v-model.trim="form.liftParameter.managerTelephone"
								placeholder="联系电话"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="重点场所：" class="input-with-col2 mr0">
							<el-select
								size="mini"
								v-model="form.liftParameter.keyPlaceStatus"
								value-key="dictionaryCode"
							>
								<el-option
									v-for="item in zdcsDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item.dictionaryCode"
									placeholder="重点场所"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="其他信息：" class="input-with-col2 mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.otherMessage"
								placeholder="其他信息"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="电梯短码：" class="input-with-col2 mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftParameter.shortCode"
								placeholder="电梯短码"
								clearable
							></el-input>
						</el-form-item>
						<h4>日期信息</h4>
						<el-form-item label="制造日期：">
							<el-date-picker
								v-model="form.liftParameter.manufactureDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="制造日期"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="校检日期：">
							<el-date-picker
								v-model="form.liftParameter.checkDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="校检日期"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item
							class="speedLimiterNextCheckDate"
							label="限速器下次校检日期："
							label-width="150px"
						>
							<el-date-picker
								v-model="form.liftParameter.speedLimiterNextCheckDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="限速器下次校检日期"
							>
							</el-date-picker>
						</el-form-item>
            <el-form-item
            	class="installDate"
            	label="安装日期："
            	label-width="150px"
            >
            	<el-date-picker
            		v-model="form.liftParameter.installDate"
            		type="date"
            		size="mini"
            		prefix-icon=" "
            		placeholder="安装日期"
            	>
            	</el-date-picker>
            </el-form-item>
					</el-tab-pane>
					<el-tab-pane label="其他信息">
						<h4>年检信息</h4>
						<el-form-item label="检验人员：">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.inspectionPersonnel"
								placeholder="检验人员"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="检验单位：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.inspectionUnit"
								placeholder="检验单位"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="单位电话：" class="input-with-col2 mr0">
							<el-input
								size="mini"
								v-number-only:11
								v-model.trim="form.liftOther.inspectionPhone"
								placeholder="检验单位电话"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="报告编号：" class="input-with-col2 mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.inspectionReportCode"
								placeholder="报告编号"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="年检日期：">
							<el-date-picker
								v-model="form.liftOther.annualInspectionDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="年检日期"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="下次年检：" class="mr0">
							<el-date-picker
								v-model="form.liftOther.nextAnnualInspectionDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="下次年检"
							>
							</el-date-picker>
						</el-form-item>
						<h4>合同信息</h4>
						<el-form-item
							label="维保开始日："
							class="label-with-five-word"
							label-width="84"
						>
							<el-date-picker
								v-model="form.liftOther.maintenanceStartDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="维保开始日"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item
							label="维保到期日："
							class="label-with-five-word mr0"
							label-width="84"
						>
							<el-date-picker
								v-model="form.liftOther.maintenanceEndDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="维保到期日"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item
							label="是否重置计划："
							class="label-with-five-word mr0"
							label-width="84"
						>
							<el-select size="mini" v-model="form.initPlanFlag">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="付款日期：">
							<el-date-picker
								v-model="form.liftOther.paymentDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="付款日期"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="税收票证：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.taxTicket"
								placeholder="税收票证"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="联系人员：">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.contractContact"
								placeholder="联系人员"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="联系电话：" class="mr0">
							<el-input
								size="mini"
								v-number-only:11
								v-model.trim="form.liftOther.contractContactPhone"
								placeholder="联系电话"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="保养方式：">
							<el-select
								size="mini"
								v-model="maintenanceMethod"
								value-key="dictionaryCode"
							>
								<el-option
									v-for="item in byfsDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item"
									placeholder="保养方式"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="配件约定：" class="mr0">
							<el-input
								size="mini"
								v-model.trim="form.liftOther.accessoriesAmount"
								placeholder="例：3000"
								v-number-only:11
								clearable
							></el-input>
						</el-form-item>
						<el-form-item
							label="维保间隔天："
							class="label-with-five-word"
							label-width="84"
							v-number-only:11
						>
							<el-input
								size="mini"
								v-model.trim="form.liftOther.maintenanceInterval"
								placeholder="例：15"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item label="电梯保险：" class="mr0">
							<el-select
								size="mini"
								v-model="liftSurance"
								value-key="dictionaryCode"
							>
								<el-option
									v-for="item in dtbxDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item"
									placeholder="电梯保险"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="有无机房：">
							<el-select
								size="mini"
								v-model="machineRoom"
								value-key="dictionaryCode"
							>
								<el-option
									v-for="item in ywjfDicts"
									:key="item.dictionaryCode"
									:label="item.dictionaryValue"
									:value="item"
									placeholder="有无机房"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="技术文档：" class="mr0">
							<el-select
								size="mini"
								multiple
                filterable
								v-model="form.technicalDocumentIdList"
							>
								<el-option
									v-for="item in documentList"
									:key="item.id"
									:label="item.brand + '-' + item.model"
									:value="item.id"
									placeholder="技术文档"
								></el-option>
							</el-select>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="电梯位置">
						<h6>
							提示：在【开始日期】-
							【结束日期】期间，手机端（有权限）可以进行电梯定位
						</h6>
						<el-form-item label="开始日期：">
							<el-date-picker
								v-model="form.positioningStartTime"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="开始日期"
                value-format="yyyy-MM-dd"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束日期：" class="mr0">
							<el-date-picker
								v-model="form.positioningEndTime"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="结束日期"
                value-format="yyyy-MM-dd"
							>
							</el-date-picker>
						</el-form-item>
						<h6>提示：点击地图选定电梯位置</h6>
						<div class="search-div">
							<el-form-item label="电梯位置：" class="mr0 mb0">
								<el-input
									size="mini"
									v-model.trim="form.liftPosition"
									placeholder="请输入电梯位置："
									clearable
								></el-input>
							</el-form-item>
							<el-button
								@click="search"
								class="search-button"
								size="mini"
								type="text"
								>搜索</el-button
							>
						</div>
						<div>
							<map-box @getAddress="getAddress" ref="mapBox"></map-box>
						</div>
					</el-tab-pane>
					<el-tab-pane label="电梯保险">
						<h4>电梯保险</h4>
						<el-form-item
							label="保险开始日期："
							class="label-with-six-word"
							label-width="98"
						>
							<el-date-picker
								v-model="form.liftOther.insuranceStartDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="保险开始日期"
                value-format="yyyy-MM-dd"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item
							label="保险结束日期："
							class="label-with-six-word mr0"
							label-width="98"
						>
							<el-date-picker
								v-model="form.liftOther.insuranceEndDate"
								type="date"
								size="mini"
								prefix-icon=" "
								placeholder="保险结束日期"
                value-format="yyyy-MM-dd"
							>
							</el-date-picker>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
				<!-- <el-form-item label="单位名称：" prop="unitName">
			  <el-input
			    size="mini"
			    v-model.trim="form.unitName"
			    placeholder="请输入单位名称"
			    clearable
			  ></el-input>
			</el-form-item>
				<el-form-item label="社会信用代码：" class="mr0 label-with-six-word" label-width="98px">
				  <el-input
				    size="mini"
				    v-model.trim="form.creditCode"
				    placeholder="请输入社会信用代码"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="联系人：">
          <el-input
            size="mini"
            v-model.trim="form.contactsName"
            placeholder="请输入联系人"
            clearable
          ></el-input>
        </el-form-item>
				<el-form-item label="联系电话：" class="mr0">
				  <el-input
				    size="mini"
				    v-model.trim="form.contactsPhone"
				    placeholder="请输入联系电话"
				    clearable
				  ></el-input>
				</el-form-item> -->
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button
				class="plr28"
				size="mini"
				type="info"
				plain
				@click="handleCancel"
				>取消</el-button
			>
			<el-button
				class="plr28"
				type="primary"
				size="mini"
				:loading="loadBtn"
				@click="handleConfirm"
				>确定</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getTemplateSimpleList, saveLift } from "@/api/ElevatorManagement";
import { getTechnicalDocumentSimpleList } from "@/api/TechnologyDocument";
import MapBox from "./MapBox";
import { mapState } from "vuex";
import { toNumber } from "lodash";

export default {
	data() {
		return {
			options: [
				{
					value: 0,
					label: "不重置",
				},
				{
					value: 1,
					label: "重置",
				},
			],
			form: {
				technicalDocumentIdList: [],
				initPlanFlag: 0,
				contactsPhone: "",
				contactsName: "",
				creditCode: "",
				unitName: "",

				equipmentCode: "",
				propertyUnitId: "",
				propertyUnitObj: {},
				propertyUnitName: "",
				projectId: "",
				liftLocation: "",
				useCertificateNumber: "",
				maintenanceOrderId: "",
				electronicWorkOrder: "",
				liftParameter: {
					liftTypeCode: "",
					liftTypeName: "",
					liftBrand: "",
					manufactureCompany: "",
					installCompany: "",
					modeOperation: "",
					unitType: "",
					factoryNumber: "",
					controlMode: "",
					nominalSpeed: "",
					nominalLoad: "",
					stationNumber: "",
					registeredUnit: "",
					registerCode: "",
					managerName: "",
					managerTelephone: "",
					keyPlaceStatus: "",
					otherMessage: "",
					manufactureDate: "",
					speedLimiterNextCheckDate: "",
					checkDate: "",
					shortCode: "",
				},
				liftOther: {
					inspectionPersonnel: "",
					inspectionUnit: "",
					inspectionPhone: "",
					inspectionReportCode: "",
					annualInspectionDate: "",
					nextAnnualInspectionDate: "",
					maintenanceStartDate: "",
					maintenanceEndDate: "",
					paymentDate: "",
					taxTicket: "",
					contractContact: "",
					contractContactPhone: "",
					maintenanceMethodCode: "",
					maintenanceMethodName: "",
					accessoriesAmount: "",
					maintenanceInterval: "",
					liftInsuranceName: "",
					liftInsuranceCode: "",
					insuranceStartDate: "",
					insuranceEndDate: "",
					machineRoomCode: "",
					machineRoomName: "",
				},
				liftPosition: "",
				lat: "",
				lon: "",
				positioningStartTime: "",
				positioningEndTime: "",
			},
			rules: {
				equipmentCode: [
					{
						required: true,
						message: "请输入单位名称",
						trigger: "blur",
					},
				],
			},
			loadBtn: false,
			projectList: [],
			unitList: [],
			templateSimpleList: [],
			liftSurance: null,
			maintenanceMethod: null,
			machineRoom: null,
			documentList: [],
		};
	},
	components: {
		MapBox,
	},
	created() {
		this.getTechnicalDocumentSimpleListFun();
	},
	computed: {
		...mapState("common/dictionary", [
			"yxztDicts",
			"tbztDicts",
			"dzgdDicts",
			"dtlxDicts",
			"zdcsDicts",
			"byfsDicts",
			"dtbxDicts",
			"ywjfDicts",
		]),
	},
	methods: {
		async getTechnicalDocumentSimpleListFun() {
			const res = await getTechnicalDocumentSimpleList();
			console.log(res);
			if (res.code === 200) {
				this.documentList = res.data;
			}
		},
		async searchTemplateSimpleList(keyword) {
			const res = await getTemplateSimpleList({
				keyword: keyword,
				size: 100,
			});
			if (res.code === 200) {
				this.templateSimpleList = res.data;
			}
		},
		async searchProjectList(keyword) {
			const res = await getProjectSimpleList({
				keyword: keyword,
				size: 100,
			});
			if (res.code === 200) {
				this.projectList = res.data;
			}
		},
		async searchUnitList(keyword) {
			const res = await getUnitSimpleList({
				keyword: keyword,
				size: 100,
			});
			if (res.code === 200) {
				this.unitList = res.data;
			}
		},
		handleBeforeClose(done) {
			this.$emit("cancel");
			done();
		},
		handleCancel() {
			this.$emit("cancel");
		},
		async handleConfirm() {
			if (this.loadBtn) return;
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					this.loadBtn = true;
					const queryData = { ...this.form };
					const needConversionNumber = [
						"electronicWorkOrder",
						"maintainStatus",
						"maintenanceOrderId",
						"projectId",
						"propertyUnitId",
						"runningStatus",
						"unitId",
					];
					needConversionNumber.forEach((item) => {
						queryData[item] = queryData[item] && toNumber(queryData[item]);
					});
					queryData.liftOther.accessoriesAmount =
						queryData.liftOther.accessoriesAmount &&
						toNumber(queryData.liftOther.accessoriesAmount);
					queryData.liftOther.maintenanceInterval =
						queryData.liftOther.maintenanceInterval &&
						toNumber(queryData.liftOther.maintenanceInterval);
					queryData.liftParameter.keyPlaceStatus =
						queryData.liftParameter.keyPlaceStatus &&
						toNumber(queryData.liftParameter.keyPlaceStatus);

					if (this.liftSurance && this.liftSurance.dictionaryCode) {
						queryData.liftOther.liftInsuranceCode =
							this.liftSurance.dictionaryCode;
						queryData.liftOther.liftInsuranceName =
							this.liftSurance.dictionaryValue;
					}
					if (this.machineRoom && this.machineRoom.dictionaryCode) {
						queryData.liftOther.machineRoomCode =
							this.machineRoom.dictionaryCode;
						queryData.liftOther.machineRoomName =
							this.machineRoom.dictionaryValue;
					}
					if (this.maintenanceMethod && this.maintenanceMethod.dictionaryCode) {
						queryData.maintenanceMethodCode = this.liftSurance.dictionaryCode;
						queryData.maintenanceMethodName = this.liftSurance.dictionaryValue;
					}

					const res = await saveLift(queryData);
					if (res.code === 200) {
						this.$message.success("添加成功");
						this.$emit("confirm");
					}
					this.loadBtn = false;
				}
			});
		},
		selectLiftObj(item) {
			if (item) {
				this.form.propertyUnitId = item.id;
				this.form.propertyUnitName = item.unitName;
			} else {
				this.form.propertyUnitId = "";
				this.form.propertyUnitName = "";
			}
		},
		getAddress(val) {
			if (val) {
				this.form.lat = val.point.lat;
				this.form.lon = val.point.lng;
				this.form.liftPosition =
					val.addressComponents.city +
					val.addressComponents.province +
					val.addressComponents.district +
					val.addressComponents.street +
					val.addressComponents.streetNumber;
			} else {
				this.form.lat = "";
				this.form.lon = "";
				this.form.liftPosition = "";
			}
		},
		search() {
			if (this.form.liftPosition) {
				this.$refs.mapBox.setCenter(this.form.liftPosition);
			}
		},
		selectLiftType(val) {
			if (val) {
				this.dtlxDicts.forEach((item) => {
					if (val === item.dictionaryCode) {
						this.form.liftParameter.liftTypeName = item.dictionaryValue;
					}
				});
			} else {
				this.form.liftParameter.liftTypeName = "";
			}
		},
	},
};
</script>
<style lang="scss" scpoed>
.search-div {
	display: flex;
	align-items: center;
	.search-button {
		margin-left: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/ElevatorManagement/components/AddLift.vue